import appAxios from '../../utils/appAxios.js';

export default {
    namespaced: true,
    state: {

        audit: {
            id: 0,
            definition: null,
            customerId: 0,
            projectId: 0,
            locationId: 0,
            checkListId: 0,
            auditTypeId: 0,
            beginDate: null,
            endDate: null,
            approveRequired: true,

        },
        auditList: [],

        CProjectList: [],
        PLocationList: [],
        LocationList: [],
        PChecklist: [],
        usersList: [],
        auditTypeList: [],
        summary: "",
        loading: false,
        recordsTotal: 0

    },


    getters: {
        _getAuditList: (state) => {
            return state.auditList
        },

        _getCProjectList: (state) => {
            return state.CProjectList
        },

        _getPLocationList: (state) => {
            return state.PLocationList
        },
        _getLocationList: (state) => {
            return state.LocationList
        },
        _getPChecklist: (state) => {
            return state.PChecklist

        },
        _getUsersList: (state) => {
            return state.usersList

        },
        _getAuditTypeList: (state) => {
            return state.auditTypeList

        },
        _getTotalRecords: (state) => {
            return state.recordsTotal
        },
        _getLoading: (state) => {
            return state.loading
        },


    },


    mutations: {

        SET_AUDITLIST: (state, Data) => {
            state.auditList = []
            state.recordsTotal = Data.TotalItemsCount
            if (Data.ListItems.length > 0) {
                Data.ListItems.forEach(item => {
                    state.auditList.push(item)
                });
            }
            state.loading = false
        }
    },
    actions: {

        // DENETİM PLANLAMA FUNCTİON

        async GET_COMMON_CPROJECT({ state }, payload) {
            if (payload != 0) {
                await appAxios.get(`/Common/GetProjectsByCustomer?customerId=${payload}`).then(response => {
                    if (response.data.Success) {
                        state.CProjectList = response.data.Data.map(customer => ({ Id: Number(customer.Id), Value: customer.Value }))
                    }
                })
            }
            else {
                state.CProjectList = []
            }
        },

        async GET_COMMON_LOCATION({ state }, payload) {
            await appAxios.get(`/Common/GetLocations?customerId=${payload}`).then(response => {
                if (response.data.Success) {
                    state.LocationList = response.data.Data.map(location => ({ Id: parseInt(location.Id), Value: location.Value }))
                }
            })



        },


        async GET_COMMON_PLOCATİON({ state }, payload) {
            if (payload !== null && payload !== "") {
                await appAxios.get(`/Common/GetLocationsByProject?projectId=${payload}`).then(response => {
                    if (response.data.Success) {
                        state.PLocationList = response.data.Data.map(location => ({ Id: Number(location.Id), Value: location.Value }))
                    }
                })
            }
        },

        async GET_COMMON_PCHECKLIST({ state }, payload) {
            if (payload !== null && payload !== "") {
                await appAxios.get(`/Common/GetChecklistsByProject?projectId=${payload}`).then(response => {
                    if (response.data.Success) {
                        state.PChecklist = response.data.Data.map(checklist => ({ Id: Number(checklist.Id), Value: checklist.Value }))
                    }
                })
            }
        },

        async GET_COMMON_USERS({ state }, payload) {
            if (payload !== null && payload !== "") {
                await appAxios.get("/Common/getUsers").then(response => {
                    if (response.data.Success) {
                        state.usersList = response.data.Data.map(user => ({ Id: Number(user.Id), Value: user.Value }))
                    }
                })
            }
        },

        async GET_COMMON_AUDİT_TYPE({ state }, payload) {
            if (payload !== null && payload !== "") {
                await appAxios.get("/Common/GetAuditTypes").then(response => {
                    if (response.data.Success) {
                        state.auditTypeList = response.data.Data.map(auditType => ({ Id: Number(auditType.Id), Value: auditType.Value }))
                    }
                })
            }
        },

        async GET_ALL_AUDIT_PLANNING_USER({ commit, state }, payload) {
            state.loading = true;
            return new Promise(resolve => {
                appAxios.post("/admin/Audit/GetAll", payload).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            }
            )
        },

        async GET_ALL_AUDIT_PLANNING({ commit, state }, payload) {
            state.loading = true;
            await appAxios.post("/admin/Audit/GetAll", payload).then(response => {
                commit("SET_AUDITLIST", response.data.Data)
            }).catch(() => state.loading = false)
        },

        async GET_AUDIT_PLANNING(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Audit/Get/${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },

        async ADD_AUDIT_PLANNING(context, payload) {
            await appAxios.post("/admin/Audit/CreateOrUpdate", payload).then(response => {
                if (response.data.Success) {
                    context.dispatch("GET_ALL_AUDIT_PLANNING", { page: 1, pageSize: 10 })
                }
            })
        },

        async DELETE_AUDIT_PLANNING(context, payload) {
            await appAxios.post("/admin/Audit/Delete", payload[0]).then(response => {
                context.dispatch("GET_ALL_AUDIT_PLANNING", payload[1])
            })
        },

        async GET_AUDIT_STATUES({ state }) {
            await appAxios.get("/Common/GetAuditStatuses").then(response => {
                if (response.data.Success) {
                    state.statusList = response.data.Data

                }
            })

        },

        async GET_COMMON_AUDIT_STATUES() {
            return new Promise(resolve => {
                appAxios.get("/Common/GetAuditStatuses").then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    } else {
                        resolve([])
                    }
                })
            })
        },

    }



}
